import { jsxs, jsx } from "react/jsx-runtime";
const IconQRSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM9 9H5V5h4v4Zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-1 6h-4V5h4v4Zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-1 6H5v-4h4v4Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 14, cy: 14, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 14, cy: 18, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 20, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 18, cy: 14, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 20, cy: 16, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 18, cy: 18, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 1 })
    ]
  }
);
export {
  IconQRSvg
};
